export const COMPANY = {
  name: "DataFrontier",
  legalName: "DataFrontier Innovations Private Limited",
  cin: "U62091KA2024PTC184641",
  city: "Bengaluru, India",
  address: "HSR Layout, Bengaluru, Karnataka, India",
  emails: {
    hello: "hello@datafrontier.co",
    careers: "careers@datafrontier.co",
    press: "press@datafrontier.co",
    legal: "legal@datafrontier.co",
    security: "security@datafrontier.co",
  },
  pypi: "https://pypi.org/project/upii/",
  smritium: "https://smritium.ai",
  semalayer: "https://semalayer.com",
};

export const BACKERS = [
  { name: "ELEVATE Nxt · Govt. of Karnataka", file: "/brand/backers/elevate-nxt.png" },
  { name: "NASSCOM deeptech", file: "/brand/backers/nasscom-deeptech.png" },
  { name: "Startup Karnataka", file: "/brand/backers/startup-karnataka.png" },
  { name: "Innovate Karnataka", file: "/brand/backers/innovate-karnataka.png" },
  { name: "DPIIT", file: "/brand/backers/dpiit.png" },
  { name: "MSME · Govt. of India", file: "/brand/backers/msme.png" },
];

export const TEAM = [
  {
    name: "Veenadhari Pola",
    role: "Founder & CEO",
    image: "/brand/team/veenadhari.jpg",
    bio: "Veenadhari founded DataFrontier on a single conviction: that the memory an AI holds about a person or an institution should belong to that person or institution — not to a model vendor. She leads research and product from Bengaluru, building sovereign memory infrastructure from India for the world.",
  },
  {
    name: "Dr. Chaitra CR",
    role: "Chief Scientist",
    image: "/brand/team/chaitra.jpg",
    bio: "Dr. Chaitra holds a PhD in Generative AI and an undergraduate degree from BITS Pilani. She leads DataFrontier's research agenda — three-signal retrieval fusion, verifiable attribution, and the evaluation methodology that lets us publish numbers instead of adjectives.",
  },
  {
    name: "Madhusudhan Anand",
    role: "Technology Advisor",
    image: "/brand/team/madhusudhan.jpg",
    bio: "Co-founder of Ambee, Madhusudhan advises DataFrontier on scaling data infrastructure from prototype to production and on developer-facing product strategy — how an open-source core becomes a category.",
  },
];

export const SOLUTIONS = [
  { slug: "healthcare", name: "Healthcare", tagline: "Longitudinal patient context — without PHI leaving the premises." },
  { slug: "financial-services", name: "Financial Services", tagline: "Regulator-defensible answers with a source for every claim." },
  { slug: "legal", name: "Legal", tagline: "Matter memory across years — cite-or-abstain as malpractice insurance." },
  { slug: "government", name: "Government", tagline: "Sovereign by construction. Air-gapped, auditable, resident." },
  { slug: "education", name: "Education", tagline: "A learning memory that belongs to the learner." },
  { slug: "sales-revenue", name: "Sales & Revenue", tagline: "Prospect memory and pipeline intelligence that compounds." },
  { slug: "developers", name: "Developers", tagline: "Build on UPII — pip install upii, MIT, offline." },
  { slug: "founders-smb", name: "Founders & SMB", tagline: "Institutional memory from day one. Flat, not metered." },
  { slug: "researchers", name: "Researchers", tagline: "A personal corpus you can query with attribution." },
  { slug: "individuals", name: "Individuals", tagline: "Your journals, notes and files — yours, offline, forever." },
];

export const NAV = [
  {
    label: "Research",
    to: "/research",
    children: [
      { label: "UPII — Personal", to: "/research/upii", desc: "Unified Personal Intelligence Infrastructure" },
      { label: "UEII — Enterprise", to: "/research/ueii", desc: "Unified Enterprise Intelligence Infrastructure" },
      { label: "The Memory Problem", to: "/research/memory-problem", desc: "Why memory is the bottleneck" },
      { label: "Publications", to: "/research/publications", desc: "Papers, notes & benchmarks" },
    ],
  },
  {
    label: "Smritium",
    to: "/smritium",
    children: [
      { label: "Overview", to: "/smritium", desc: "The sovereign memory layer for AI" },
      { label: "How it works", to: "/smritium/how-it-works", desc: "Ingest, rehydrate, answer" },
      { label: "Security", to: "/smritium/security", desc: "Local-first as a security model" },
      { label: "Changelog", to: "/smritium/changelog", desc: "Release notes" },
    ],
  },
  {
    label: "Products",
    to: "/products/asoc",
    children: [
      { label: "ASOC", to: "/products/asoc", desc: "AI revenue operating system for outbound sales" },
      { label: "Smritium", to: "/smritium", desc: "The sovereign memory layer" },
    ],
  },
  { label: "Solutions", to: "/solutions" },
  { label: "Blog", to: "/blog" },
  {
    label: "Company",
    to: "/company/about",
    children: [
      { label: "About", to: "/company/about", desc: "Mission & team" },
      { label: "Careers", to: "/company/careers", desc: "We hire people who think memory matters" },
      { label: "Forward Deployed Eng", to: "/company/forward-deployed", desc: "We embed an engineer to build the solution" },
      { label: "Patents", to: "/company/patents", desc: "Filed, pending" },
      { label: "Press", to: "/company/press", desc: "Media & brand" },
      { label: "Contact", to: "/company/contact", desc: "Talk to us" },
    ],
  },
];

export const FOOTER = [
  {
    title: "Research",
    links: [
      { label: "UPII", to: "/research/upii" },
      { label: "UEII", to: "/research/ueii" },
      { label: "The Memory Problem", to: "/research/memory-problem" },
      { label: "Publications", to: "/research/publications" },
    ],
  },
  {
    title: "Products",
    links: [
      { label: "Smritium", to: "/smritium" },
      { label: "ASOC", to: "/products/asoc" },
      { label: "Semalayer", to: "/products/semalayer" },
      { label: "UPII on PyPI", href: "https://pypi.org/project/upii/", external: true },
    ],
  },
  {
    title: "Solutions",
    links: SOLUTIONS.map((s) => ({ label: s.name, to: `/solutions/${s.slug}` })),
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/company/about" },
      { label: "Careers", to: "/company/careers" },
      { label: "Forward Deployed Eng", to: "/company/forward-deployed" },
      { label: "Patents", to: "/company/patents" },
      { label: "Press", to: "/company/press" },
      { label: "Contact", to: "/company/contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Terms of Service", to: "/legal/terms" },
      { label: "Privacy Policy", to: "/legal/privacy" },
      { label: "Acceptable Use", to: "/legal/acceptable-use" },
      { label: "Data Processing (DPA)", to: "/legal/data-processing" },
      { label: "Open Source & Licenses", to: "/legal/open-source" },
      { label: "Refund & Cancellation", to: "/legal/refund-cancellation" },
      { label: "Security Disclosure", to: "/legal/security-disclosure" },
      { label: "Cookie Policy", to: "/legal/cookies" },
    ],
  },
];
